import { Backdrop, CircularProgress } from "@mui/material";

function Loader() {
  return (
    <div style={{ position: "absolute", left: "50%", top: "50%" }}>
      <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 1,
          backdropFilter: "blur(10px)",
        }}
        open={true}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
}

export default Loader;
